<template>
  <div class="wrap">
     <!-- <p class="searchTitle"><span>莘知</span>题库</p>
     <p class="text"><span></span><span class="shuxian"></span>公招考试一步到位不是梦<span></span><span></span></p> -->
		 <div class="headerimg">
			 <img style="width:439px;height:188px"  src="/images/title.png" alt="">
		 </div>
     	<div class="header-search">
					<p>
					
						<input  type="text" placeholder="你可以输入完整题干、题目、关键字进行搜索" v-model="searchValue" @keyup.13="search" />
					</p>
					<el-button  class="butt"  type="primary" @click="search">	       <i class="el-icon-search"></i> &nbsp搜索</el-button>
       </div>
			 <!-- <p class="hottext"> 你可以输入完整题干、题目、关键字进行搜索</p>   -->
        <!-- <p class="hottext"><span>大家都在搜</span>:&nbsp<span   @click="searchnew(item)"   v-for="(item,index) in searchs" :key='index'>{{item}}、</span></p> -->
        <div class="common"><span>常见试题</span><span class="righttext">教招考编，莘知为您，保驾护航</span></div>
        <div class="content">
           <div  :alt="item.title"  v-for="(item,index) in list " :key="index"   @click="goup(item.id)"     class="contenttext"><span >{{item.genre_text}}</span>{{item.title}}</div>
         

      
        </div>

					<el-dialog :visible.sync="showLogin" :append-to-body="true" :show-close="false" width="400px"
						v-if="showLogin" :close-on-click-modal="false">
						<Login :loginType="loginType" v-on:listenLogin="listenLogin"    @show="onlin"></Login>
					</el-dialog>
  </div>
</template>
<script>
import Login from "@/components/Login.vue";
export default {
	components:{Login},
    data(){
      return{
        searchValue:'',
				searchs:'',
				list:'',
				showLogin:'',
      }
    },
		created(){
			this.getsearchList()
		},
    methods:{
				listenLogin(item) {
				this.loginType = item;
			},	
			// 大家都在搜索
			searchnew(title){
					this.searchValue =title
					this.search()
			},

			//  获取列表
			 getsearchList(){
				 	this.$api.searchList().then((res)=>{
						 //console.log(res)
						 this.searchs =res.data.search
						 this.list = res.data.list
					 })
			 },
			// 热门试题跳转
			goup(id){
				// if(localStorage.getItem('UserToken') =='' || localStorage.getItem('UserToken') ==null ){
				// 	this.loginType = 'login'
				// 	this.showLogin = true
				// 	//console.log(this)
				// 	this.$message.error('请先登录')
				// 			return 
				// }



				//console.log(id)
					this.$router.push({
						path:'/detail',
						query:{
							id:id
						}
					})
			},
				onlin(show){
				//console.log(show)
				this.showLogin =show			
			},
      // 搜索
        search(){
          
					if (this.searchValue.trim() == "" ) {
					this.$message({
						message: "请输入搜索关键字",
						type: "error",
						showClose: true,
					});
				} else {
					if (this.$route.path == "/search") {
						this.$router.push({
							path: "/search",
							query: {
								key:   this.searchValue.trim() 
							},
						});
						// this.$link(query);
						this.$router.go(0);
						this.searchValue = "";
					} else {
						this.$router.push({
							path: "/search",
							query: {
								key: this.searchValue
							},
						});
						this.searchValue = "";
					}
				}

					}
 
        }
 
}
</script>

<style scoped  >
 *{padding: 0;margin: 0; box-sizing: border-box;outline: none;}
 .searchTitle{    margin-top: 90px;       text-align: center;height: 57px;font-size: 58px;font-family: Source Han Serif CN;color: #130d0e;line-height: 7px;font-weight: 800;}
 .searchTitle:first-child span{color:red;}
 .text{text-align:center;font-size: 16px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;line-height: 4px;}
 .header-search{    margin-top: 40px;   display: flex;align-content: center;justify-content: center; font-size: 18px;font-family: Microsoft YaHei;font-weight: 400;color: #FFFFFF;line-height: 4px; } 
 .header-search p input{width: 536px;height: 46px;background: #FFFFFF;border:3px solid #e60012; text-indent:18px ; }
 .butt{border-radius: 0;}
 .hottext{ width: 623px; margin: 0 auto;  margin-top: 15px;  }
 .hottext :nth-of-type(1){font-weight: 800;}
 .hottext span{cursor: pointer;}
 .common{display: flex; align-content: center; justify-content: space-between; font-size: 16px;font-family: Microsoft YaHei;font-weight: bold;color: #333333; padding: 12px 0; border-bottom: 1px solid #e4e4e4; margin-top: 32px; }
 .righttext{font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #666666;}
 .content{ padding: 20px px; display: flex;  flex-wrap: wrap;  } 
 .contenttext{width:585px; font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #666666;padding: 26px 0; height: 50px; overflow: hidden; cursor: pointer; }
 .contenttext:nth-child(2n-1){margin-right: 20px;}	
.contenttext span{  margin-right: 8px; display: inline-block;  text-align: center;  width: 69px;height: 24px;background: #FEF2F3;border-radius: 2px;font-size: 12px;font-family: Microsoft YaHei;font-weight: 400;color: #E60012;line-height: 24px;  	
}
.headerimg{text-align: center ; width: 100%;padding-top: 60px; }
</style>